import { render } from "./RestaurantContractForm.vue?vue&type=template&id=42cc78c6&scoped=true"
import script from "./RestaurantContractForm.vue?vue&type=script&lang=js"
export * from "./RestaurantContractForm.vue?vue&type=script&lang=js"

import "./RestaurantContractForm.vue?vue&type=style&index=0&id=42cc78c6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-42cc78c6"

export default script